const { config } = require('@sstdev/lib_metadata-config');
const Blockly = require('blockly');

const TOOLTIP = 'Display 3 columns, or rows, with 1 of them greedy';

function addBlockSpecificFields(color, blocklyBlock, mdcBlock, line1OfInputs) {

    blocklyBlock.setTooltip(TOOLTIP);

    //set inputs to be arranged vertically.
    //Meaning each (dummy)input starts a new line
    blocklyBlock.setInputsInline(false);

    const greedyOptions = new Blockly.FieldDropdown(config.greedyLayoutOptions);
    greedyOptions.setValue('MIDDLE');
    line1OfInputs
        .appendField('  Greedy Section:')
        .appendField(greedyOptions, 'greedySection');

    line1OfInputs
        .appendField('  Section Arrangement:')
        .appendField(
            new Blockly.FieldDropdown([
                ['Top To Bottom', 'TOP2BOTTOM'],
                ['Left To Right', 'LEFT2RIGHT']
            ]),
            'flexDirection'
        );

    const line2OfInputs = blocklyBlock
        .appendDummyInput()
        .setAlign(Blockly.ALIGN_RIGHT)
        .appendField('  Allow Scroll')
        .appendField(new Blockly.FieldCheckbox('false'), 'allowScroll');

   line2OfInputs
        .appendField('  Darken Background')
        .appendField(new Blockly.FieldCheckbox('false'), 'darkenBackground');

    line2OfInputs
        .appendField('  Padding Left:')
        .appendField(new Blockly.FieldNumber(), 'paddingLeft')
        .appendField('px');
    line2OfInputs
        .appendField('  Padding Right:')
        .appendField(new Blockly.FieldNumber(), 'paddingRight')
        .appendField('px');
    line2OfInputs
        .appendField('  Padding Top:')
        .appendField(new Blockly.FieldNumber(), 'paddingTop')
        .appendField('px');
    line2OfInputs
        .appendField('  Padding Bottom:')
        .appendField(new Blockly.FieldNumber(), 'paddingBottom')
        .appendField('px');

    blocklyBlock
        .appendStatementInput('first')
        .setAlign(Blockly.ALIGN_RIGHT)
        .setCheck(['layout', 'list'])
        .appendField('First:', 'first');
    blocklyBlock
        .appendStatementInput('middle')
        .setAlign(Blockly.ALIGN_RIGHT)
        .setCheck(['layout', 'list'])
        .appendField('Middle:', 'middle');
    blocklyBlock
        .appendStatementInput('last')
        .setAlign(Blockly.ALIGN_RIGHT)
        .setCheck(['layout', 'list'])
        .appendField('Last:', 'last');

}

function convertCustomFieldsToCode(code, blocklyBlock) {
    code.greedySection = blocklyBlock.getFieldValue('greedySection');
    let firstSection = JSON.parse('[' + Blockly.JavaScript.statementToCode(blocklyBlock, 'first') + ']');
    code.firstSection = firstSection.map(l => l.id);
    let middleSection = JSON.parse('[' + Blockly.JavaScript.statementToCode(blocklyBlock, 'middle') + ']');
    code.middleSection = middleSection.map(l => l.id);
    let lastSection = JSON.parse('[' + Blockly.JavaScript.statementToCode(blocklyBlock, 'last') + ']');
    code.lastSection = lastSection.map(l => l.id);
    code.flexDirection = blocklyBlock.getFieldValue('flexDirection').toLowerCase();
    code.padding = {
        left: blocklyBlock.getFieldValue('paddingLeft'),
        right: blocklyBlock.getFieldValue('paddingRight'),
        top: blocklyBlock.getFieldValue('paddingTop'),
        bottom: blocklyBlock.getFieldValue('paddingBottom')
    };
    // expected as string:
    code.allowScroll = blocklyBlock.getFieldValue('allowScroll');

    return code;
}

module.exports = { addBlockSpecificFields, convertCustomFieldsToCode };
